module.exports = __webpack_public_path__ + "static/Image10@2x-5bef1f114579636f6676278bf1c8c724.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image10@2x.jpg
// module id = 903
// module chunks = 227233210825294 244429959259914